var map = {
	"./cny-flower.png": 2607,
	"./paper.png": 2608,
	"./prize-1-bm.webp": 2609,
	"./prize-1-cn.webp": 2610,
	"./prize-1.webp": 2611,
	"./prize-2-bm.webp": 2612,
	"./prize-2-cn.webp": 2613,
	"./prize-2.webp": 2614,
	"./prize-3-bm.webp": 2615,
	"./prize-3-cn.webp": 2616,
	"./prize-3.webp": 2617,
	"./prize-4-bm.webp": 2618,
	"./prize-4-cn.webp": 2619,
	"./prize-4.webp": 2620,
	"./prize-5-bm.webp": 2621,
	"./prize-5-cn.webp": 2622,
	"./prize-5.webp": 2623,
	"./prize-6-bm.webp": 2624,
	"./prize-6-cn.webp": 2625,
	"./prize-6.webp": 2626,
	"./star.svg": 2627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;